/* [04] Field Camp: totem stats. Counts what people do at the stand, on this totem only (localStorage, no personal data).
   Which idle slide makes people stop, how far they get (menu > product > cart > pay > done), game, photo, globe.
   Open the panel: press and hold the top-left corner of the screen for 3 seconds. */
(()=>{
if(window.__stats04)return;window.__stats04=1;
const KEY='fc04_stats',$=s=>document.querySelector(s);
const day=()=>{const d=new Date();return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')};
let DB;try{DB=JSON.parse(localStorage.getItem(KEY)||'{}')}catch(e){DB={}}
if(!DB.days)DB.days={};
let saveT=0;const save=()=>{clearTimeout(saveT);saveT=setTimeout(()=>{try{localStorage.setItem(KEY,JSON.stringify(DB))}catch(e){}},400)};
const D=()=>{const k=day();if(!DB.days[k])DB.days[k]={c:{},sessions:[]};return DB.days[k]};
const inc=(name,n)=>{const c=D().c;c[name]=(c[name]||0)+(n||1);save()};
const vis=el=>!!el&&!el.hidden&&el.offsetParent!==null;

/* ---- sessions: start at the first touch, end after 45 s without touches ---- */
const STEPS=['tap','menu','product','cart','order','pay','done'];
let sess=null,idleT=0;
function touch(){
  if(!sess){sess={t:Date.now(),max:0,from:slideNow()};inc('sessions')}
  sess.last=Date.now();clearTimeout(idleT);idleT=setTimeout(endSession,45000);
}
function step(s){if(!sess)touch();const i=STEPS.indexOf(s);if(i>sess.max)sess.max=i}
function endSession(){
  if(!sess)return;const dur=Math.round(((sess.last||Date.now())-sess.t)/1000);
  const list=D().sessions;list.push([sess.t,dur,sess.max,sess.from||'']);if(list.length>3000)list.shift();
  sess=null;save();
}
/* ---- idle slides ---- */
function slideNow(){const s=$('.idl.on .idl-s.on');if(!s)return '';const it=[...s.querySelectorAll('.big i')].map(i=>i.textContent);const t=it.length?it.join(' '):((s.querySelector('.cap')||{}).textContent||'');return t.replace(/\s+/g,' ').trim().slice(0,40)}
let lastSlide='';

/* ---- everything is observed from outside: no changes to the other kiosk scripts ---- */
const mo=new MutationObserver(ms=>{
  for(const m of ms){
    const t=m.target;if(!(t instanceof Element))continue;
    if(m.attributeName==='hidden'){
      if(t.id==='s-menu'&&!t.hidden)step('menu');
      else if(t.id==='s-order'&&!t.hidden){step('order')}
      else if(t.id==='s-pay'&&!t.hidden){step('pay');inc('pay_screen')}
      else if(t.id==='s-thanks'&&!t.hidden){step('done');inc('orders_done')}
      else if(t.id==='mr'&&!t.hidden){touch();inc('game_open')}
      else if(t.id==='sf'&&!t.hidden){touch();inc('photo_open')}
    }else if(m.attributeName==='class'){
      if(t.id==='sheet'&&t.classList.contains('open')){step('product');const ti=$('#pdTitle');inc('product_open');if(ti&&ti.textContent)inc('p:'+ti.textContent.trim().slice(0,40))}
      else if(t.id==='toast'&&t.classList.contains('on')){step('cart');inc('add_to_cart')}
      else if(t.classList.contains('idl-s')&&t.classList.contains('on')){const s=slideNow();if(s&&s!==lastSlide){lastSlide=s;inc('v:'+s)}}
    }else if(m.type==='childList'&&t.id==='mrEnd'&&m.addedNodes.length){
      inc(t.querySelector('.mr-win')?'game_win':'game_lose');
    }
  }
});
mo.observe(document.body,{subtree:true,attributes:true,attributeFilter:['hidden','class'],childList:true});

/* taps, in the capture phase so the kiosk scripts cannot hide them */
document.addEventListener('pointerdown',e=>{
  if(e.target.closest&&e.target.closest('#st04'))return;
  const onIdle=e.target.closest&&e.target.closest('.idl.on');
  const fresh=!sess;touch();
  if(onIdle&&fresh){const s=slideNow();if(s){inc('s:'+s);sess.stop='s:'+s}}   /* the slide that made someone stop */
  if(e.target.closest&&e.target.closest('canvas.gl')&&!(e.clientX<90&&e.clientY<90))inc('globe_touch');
},true);
const CLICKS={'#mrGo':'game_start','#mrUse':'game_code_used','#sfGo':'photo_camera','#sfPrint':'photo_print','#payHere':'pay_here','#prPrint':'receipt_print','#idleReset':'abandon_reset'};
document.addEventListener('click',e=>{
  if(!e.target.closest)return;
  for(const k in CLICKS)if(e.target.closest(k)){inc(CLICKS[k]);break}
  const m=e.target.closest('[data-mode]');if(m)inc('mode:'+m.getAttribute('data-mode'));
  const w=e.target.closest('[data-who]');if(w)inc('who:'+w.getAttribute('data-who'));
  const l=e.target.closest('#langs [data-l]');if(l&&l.getAttribute('data-l')==='en')inc('lang_en');
},true);
/* the phone QR on the pay screen counts as "pay on phone" when the pay screen is left without paying here */

/* ---- panel ---- */
const css=document.createElement('style');
css.textContent=`#st04{position:fixed;inset:0;z-index:2147483000;background:#030302;color:#fff;font:14px/1.4 "Inter Tight",Helvetica,Arial,sans-serif;overflow:auto;padding:28px clamp(16px,4vw,48px) 40px}
#st04[hidden]{display:none}
#st04 h1{font-size:clamp(28px,5vw,56px);letter-spacing:-.04em;line-height:.95;text-transform:uppercase;margin:0 0 4px}
#st04 .sub{opacity:.6;font-size:12px;letter-spacing:.08em;text-transform:uppercase}
#st04 .bar{display:flex;flex-wrap:wrap;gap:8px;margin:18px 0}
#st04 button{font:inherit;font-weight:700;border:1.5px solid #fff;background:none;color:#fff;border-radius:999px;padding:10px 16px;cursor:pointer}
#st04 button.p{background:#808D45;border-color:#808D45;color:#030302}
#st04 .g{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:1px;background:#2a2c24;border:1px solid #2a2c24;margin:14px 0}
#st04 .k{background:#030302;padding:14px}
#st04 .k b{display:block;font-size:34px;letter-spacing:-.03em;font-variant-numeric:tabular-nums}
#st04 .k span{font-size:11px;letter-spacing:.1em;text-transform:uppercase;opacity:.7}
#st04 h2{font-size:12px;letter-spacing:.12em;text-transform:uppercase;margin:26px 0 8px;color:#808D45}
#st04 .row{display:grid;grid-template-columns:minmax(0,1fr) 60px 40%;gap:12px;align-items:center;padding:7px 0;border-bottom:1px solid #22241d}
#st04 .row i{display:block;height:8px;background:#808D45}
#st04 .row em{font-style:normal;text-align:right;font-variant-numeric:tabular-nums;font-weight:700}
#st04 .none{opacity:.5;padding:8px 0}`;
document.head.appendChild(css);
const P=document.createElement('div');P.id='st04';P.hidden=true;document.body.appendChild(P);
let viewDay=day(),armReset=false,closeT=0;
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
function rows(obj,max){const a=Object.entries(obj).sort((x,y)=>y[1]-x[1]);if(!a.length)return '<div class="none">Ancora niente.</div>';const top=a[0][1]||1;return a.slice(0,max||12).map(([k,v])=>`<div class="row"><span>${esc(k)}</span><em>${v}</em><i style="width:${Math.max(2,100*v/top)}%"></i></div>`).join('')}
function render(){
  const d=DB.days[viewDay]||{c:{},sessions:[]},c=d.c,S=d.sessions;
  const pre=p=>Object.fromEntries(Object.entries(c).filter(([k])=>k.startsWith(p)).map(([k,v])=>[k.slice(p.length),v]));
  const n=S.length,avg=n?Math.round(S.reduce((s,x)=>s+x[1],0)/n):0;
  const reach=i=>S.filter(x=>x[2]>=i).length;
  const funnel={};[['Hanno toccato',0],['Menu',1],['Prodotto aperto',2],['Nel carrello',3],['Riepilogo ordine',4],['Pagamento',5],['Ordine fatto',6]].forEach(([l,i])=>funnel[l]=reach(i));
  const days=Object.keys(DB.days).sort();const loc=(()=>{try{const i=window.FC04_INFO&&window.FC04_INFO();return i&&(i.name||i.place||i.loc)||''}catch(e){return ''}})();
  P.innerHTML=`<h1>Field Camp<br>dati del totem</h1><div class="sub">${esc(viewDay)}${loc?' · '+esc(loc):''} · solo questo totem</div>
  <div class="bar"><button data-a="prev">‹ Giorno prima</button><button data-a="next">Giorno dopo ›</button><button data-a="csv" class="p">Scarica CSV</button><button data-a="reset">${armReset?'Tocca di nuovo per azzerare tutto':'Azzera'}</button><button data-a="close">Chiudi</button></div>
  <div class="g">
   <div class="k"><b>${n}</b><span>Persone che hanno toccato</span></div>
   <div class="k"><b>${avg}s</b><span>Tempo medio</span></div>
   <div class="k"><b>${c.orders_done||0}</b><span>Ordini chiusi qui</span></div>
   <div class="k"><b>${c.pay_screen||0}</b><span>Arrivati al pagamento</span></div>
   <div class="k"><b>${c.game_start||0}</b><span>Partite Moss Run</span></div>
   <div class="k"><b>${c.game_win||0}</b><span>Vinte · ${c.game_code_used||0} codici usati</span></div>
   <div class="k"><b>${c.photo_print||0}</b><span>Cartoline stampate</span></div>
   <div class="k"><b>${c.globe_touch||0}</b><span>Tocchi sul globo</span></div>
  </div>
  <h2>Quale slide fa fermare la gente</h2>${rows(pre('s:'))}
  <h2>Fin dove arrivano</h2>${rows(funnel,7).replace(/<div class="row">/g,'<div class="row">')}
  <h2>Prodotti aperti</h2>${rows(pre('p:'))}
  <h2>Consegna scelta</h2>${rows(pre('mode:'))}
  <h2>Chi paga</h2>${rows(pre('who:'))}
  <h2>Slide mostrate</h2>${rows(pre('v:'))}
  <div class="sub" style="margin-top:24px">Giorni salvati: ${days.length?esc(days.join(', ')):'nessuno'} · inglese scelto ${c.lang_en||0} volte · ${c.abandon_reset||0} abbandoni dal timer</div>`;
}
function csv(){
  const lines=['giorno,metrica,valore'];
  Object.keys(DB.days).sort().forEach(k=>{const d=DB.days[k];Object.entries(d.c).forEach(([m,v])=>lines.push(`${k},"${String(m).replace(/"/g,'""')}",${v}`));
    const S=d.sessions;lines.push(`${k},sessioni,${S.length}`);if(S.length)lines.push(`${k},durata_media_s,${Math.round(S.reduce((s,x)=>s+x[1],0)/S.length)}`)});
  lines.push('');lines.push('inizio,durata_s,passo_massimo,slide_di_partenza');
  Object.keys(DB.days).sort().forEach(k=>DB.days[k].sessions.forEach(x=>lines.push(`${new Date(x[0]).toISOString()},${x[1]},${STEPS[x[2]]||x[2]},"${String(x[3]||'').replace(/"/g,'""')}"`)));
  const a=document.createElement('a');a.href=URL.createObjectURL(new Blob([lines.join('\n')],{type:'text/csv'}));a.download='field-camp-dati-'+day()+'.csv';document.body.appendChild(a);a.click();setTimeout(()=>{URL.revokeObjectURL(a.href);a.remove()},1000);
}
P.addEventListener('click',e=>{
  e.stopPropagation();const b=e.target.closest('button');if(!b)return;const a=b.dataset.a;const days=Object.keys(DB.days).sort();
  armClose();
  if(a==='close'){P.hidden=true;armReset=false;return}
  if(a==='csv')return csv();
  if(a==='reset'){if(!armReset){armReset=true;render();setTimeout(()=>{armReset=false;if(!P.hidden)render()},5000);return}DB={days:{}};armReset=false;save();viewDay=day();render();return}
  const i=days.indexOf(viewDay);
  if(a==='prev'&&i>0)viewDay=days[i-1];
  if(a==='next'&&i>-1&&i<days.length-1)viewDay=days[i+1];
  render();
});
P.addEventListener('pointerdown',e=>e.stopPropagation());
function armClose(){clearTimeout(closeT);closeT=setTimeout(()=>{P.hidden=true},90000)}
/* the staff touch that opens the panel is not a visitor: drop it */
function dropStaff(){if(sess&&Date.now()-sess.t<6000){const c=D().c;c.sessions=Math.max(0,(c.sessions||1)-1);if(sess.stop&&c[sess.stop]){c[sess.stop]--;if(!c[sess.stop])delete c[sess.stop]}sess=null;clearTimeout(idleT);save()}else endSession()}
function open(){dropStaff();viewDay=day();render();P.hidden=false;armClose()}
/* hold the top-left corner for 3 s */
let holdT=0;
document.addEventListener('pointerdown',e=>{if(e.clientX<90&&e.clientY<90){clearTimeout(holdT);holdT=setTimeout(open,3000)}},true);
['pointerup','pointercancel','pointerleave'].forEach(ev=>document.addEventListener(ev,()=>clearTimeout(holdT),true));
window.FC04_STATS={open,inc};
})();
